import { render, staticRenderFns } from "./errorDetails.vue?vue&type=template&id=6ef0534e&scoped=true&"
import script from "./errorDetails.vue?vue&type=script&lang=js&"
export * from "./errorDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ef0534e",
  null
  
)

export default component.exports